"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DOMAINS_MC_ORIGEN = exports.DOMAINS = void 0;
var DOMAINS = {
  // Directo
  "onboarding.capitaria.com": "direct",
  "webpay3g.transbank.cl": "direct",
  "webpay3gint.transbank.cl": "direct",
  "www.capitaria.com": "direct",
  // Organico
  "360.cn": "organic",
  "aliceadsl.fr": "organic",
  "ar.search.yahoo.com": "organic",
  "baidu.com": "organic",
  "biglobe.ne.jp": "organic",
  "bottraffic4free.xyz": "organic",
  "buscador.terra.com.br": "organic",
  "capitaria-online.com": "organic",
  "cbsearch.site": "organic",
  "ccyy.ooo": "organic",
  "cl.search.yahoo.com": "organic",
  "co.search.yahoo.com": "organic",
  "duckduckgo.com": "organic",
  "es.search.yahoo.com": "organic",
  "g.cn": "organic",
  "go.mail.ru": "organic",
  "goo.ne.jp": "organic",
  "google.ac": "organic",
  "google.ad": "organic",
  "google.ae": "organic",
  "google.al": "organic",
  "google.am": "organic",
  "google.as": "organic",
  "google.at": "organic",
  "google.az": "organic",
  "google.ba": "organic",
  "google.be": "organic",
  "google.bf": "organic",
  "google.bg": "organic",
  "google.bi": "organic",
  "google.bj": "organic",
  "google.bs": "organic",
  "google.bt": "organic",
  "google.by": "organic",
  "google.ca": "organic",
  "google.cat": "organic",
  "google.cc": "organic",
  "google.cd": "organic",
  "google.cf": "organic",
  "google.cg": "organic",
  "google.ch": "organic",
  "google.ci": "organic",
  "google.cl": "organic",
  "google.cm": "organic",
  "google.cn": "organic",
  "google.co.ao": "organic",
  "google.co.bw": "organic",
  "google.co.ck": "organic",
  "google.co.cr": "organic",
  "google.co.id": "organic",
  "google.co.il": "organic",
  "google.co.in": "organic",
  "google.co.jp": "organic",
  "google.co.ke": "organic",
  "google.co.kr": "organic",
  "google.co.ls": "organic",
  "google.co.ma": "organic",
  "google.co.mz": "organic",
  "google.co.nz": "organic",
  "google.co.th": "organic",
  "google.co.tz": "organic",
  "google.co.ug": "organic",
  "google.co.uk": "organic",
  "google.co.uz": "organic",
  "google.co.ve": "organic",
  "google.co.vi": "organic",
  "google.co.za": "organic",
  "google.co.zm": "organic",
  "google.co.zw": "organic",
  "google.com.af": "organic",
  "google.com.ag": "organic",
  "google.com.ai": "organic",
  "google.com.ar": "organic",
  "google.com.au": "organic",
  "google.com.bd": "organic",
  "google.com.bh": "organic",
  "google.com.bn": "organic",
  "google.com.bo": "organic",
  "google.com.br": "organic",
  "google.com.bz": "organic",
  "google.com.co": "organic",
  "google.com.cu": "organic",
  "google.com.cy": "organic",
  "google.com.do": "organic",
  "google.com.ec": "organic",
  "google.com.eg": "organic",
  "google.com.et": "organic",
  "google.com.fj": "organic",
  "google.com.gh": "organic",
  "google.com.gi": "organic",
  "google.com.gt": "organic",
  "google.com.hk": "organic",
  "google.com.jm": "organic",
  "google.com.kh": "organic",
  "google.com.kw": "organic",
  "google.com.lb": "organic",
  "google.com.lc": "organic",
  "google.com.ly": "organic",
  "google.com.mm": "organic",
  "google.com.mt": "organic",
  "google.com.mx": "organic",
  "google.com.my": "organic",
  "google.com.na": "organic",
  "google.com.nf": "organic",
  "google.com.ng": "organic",
  "google.com.ni": "organic",
  "google.com.np": "organic",
  "google.com.om": "organic",
  "google.com.pa": "organic",
  "google.com.pe": "organic",
  "google.com.pg": "organic",
  "google.com.ph": "organic",
  "google.com.pk": "organic",
  "google.com.pr": "organic",
  "google.com.py": "organic",
  "google.com.qa": "organic",
  "google.com.sa": "organic",
  "google.com.sb": "organic",
  "google.com.sg": "organic",
  "google.com.sl": "organic",
  "google.com.sv": "organic",
  "google.com.tj": "organic",
  "google.com.tr": "organic",
  "google.com.tw": "organic",
  "google.com.ua": "organic",
  "google.com.uy": "organic",
  "google.com.vc": "organic",
  "google.com.vn": "organic",
  "google.com": "organic",
  "google.cv": "organic",
  "google.cz": "organic",
  "google.de": "organic",
  "google.dj": "organic",
  "google.dk": "organic",
  "google.dm": "organic",
  "google.dz": "organic",
  "google.ee": "organic",
  "google.es": "organic",
  "google.fi": "organic",
  "google.fm": "organic",
  "google.fr": "organic",
  "google.ga": "organic",
  "google.ge": "organic",
  "google.gf": "organic",
  "google.gg": "organic",
  "google.gl": "organic",
  "google.gm": "organic",
  "google.gp": "organic",
  "google.gr": "organic",
  "google.gy": "organic",
  "google.hn": "organic",
  "google.hr": "organic",
  "google.ht": "organic",
  "google.hu": "organic",
  "google.ie": "organic",
  "google.im": "organic",
  "google.io": "organic",
  "google.iq": "organic",
  "google.is": "organic",
  "google.it": "organic",
  "google.je": "organic",
  "google.jo": "organic",
  "google.kg": "organic",
  "google.ki": "organic",
  "google.kz": "organic",
  "google.la": "organic",
  "google.li": "organic",
  "google.lk": "organic",
  "google.lt": "organic",
  "google.lu": "organic",
  "google.lv": "organic",
  "google.md": "organic",
  "google.me": "organic",
  "google.mg": "organic",
  "google.mk": "organic",
  "google.ml": "organic",
  "google.mn": "organic",
  "google.ms": "organic",
  "google.mu": "organic",
  "google.mv": "organic",
  "google.mw": "organic",
  "google.ne": "organic",
  "google.nl": "organic",
  "google.no": "organic",
  "google.nr": "organic",
  "google.nu": "organic",
  "google.pl": "organic",
  "google.pn": "organic",
  "google.ps": "organic",
  "google.pt": "organic",
  "google.ro": "organic",
  "google.rs": "organic",
  "google.ru": "organic",
  "google.rw": "organic",
  "google.sc": "organic",
  "google.se": "organic",
  "google.sh": "organic",
  "google.si": "organic",
  "google.sk": "organic",
  "google.sm": "organic",
  "google.sn": "organic",
  "google.so": "organic",
  "google.sr": "organic",
  "google.st": "organic",
  "google.td": "organic",
  "google.tg": "organic",
  "google.tk": "organic",
  "google.tl": "organic",
  "google.tm": "organic",
  "google.tn": "organic",
  "google.to": "organic",
  "google.tt": "organic",
  "google.vg": "organic",
  "google.vu": "organic",
  "google.ws": "organic",
  "googleapis.com": "organic",
  "int.search.tb.ask.com": "organic",
  "isearch.avg.com": "organic",
  "local.msn.com": "organic",
  "m.baidu.com": "organic",
  "m.sogou.com": "organic",
  "m.yahoo.com": "organic",
  "mx.search.yahoo.com": "organic",
  "najdi.si": "organic",
  "news.google.com": "organic",
  "pe.search.yahoo.com": "organic",
  "r.search.yahoo.com": "organic",
  "rakuten.co.jp": "organic",
  "rambler.ru": "organic",
  "search-results.com": "organic",
  "search.aol.fr": "organic",
  "search.auone.jp": "organic",
  "search.babylon.com": "organic",
  "search.becovi.com": "organic",
  "search.centrum.cz": "organic",
  "search.comcast.net": "organic",
  "search.conduit.com": "organic",
  "search.incredimail.com": "organic",
  "search.lycos.de": "organic",
  "search.mysearch.com": "organic",
  "search.netscape.com": "organic",
  "search.smt.docomo.ne.jp": "organic",
  "search.tut.by": "organic",
  "search.ukr.net": "organic",
  "search.virgilio.it": "organic",
  "search.visymo.com": "organic",
  "searchencrypt.com": "organic",
  "sesam.no": "organic",
  "so.com": "organic",
  "so.m.sm.cn": "organic",
  "sogou.com": "organic",
  "szukaj.onet.pl": "organic",
  "tw.search.yahoo.com": "organic",
  "uk.search.yahoo.com": "organic",
  "ve.search.yahoo.com": "organic",
  "wap.sogou.com": "organic",
  "www.alice.com": "organic",
  "www.alltheweb.com": "organic",
  "www.altavista.com": "organic",
  "www.aol.com": "organic",
  "www.ask.com": "organic",
  "www.baidu.com": "organic",
  "www.bing.com": "organic",
  "www.cnn.comSEARCH": "organic",
  "www.daum.net": "organic",
  "www.ecosia.org": "organic",
  "www.ekolay.net": "organic",
  "www.eniro.se": "organic",
  "www.globo.combusca": "organic",
  "www.google.cl": "organic",
  "www.google.com.br": "organic",
  "www.google.com.co": "organic",
  "www.google.com.hk": "organic",
  "www.google.com.mx": "organic",
  "www.google.com.pe": "organic",
  "www.google.com.uy": "organic",
  "www.google.com": "organic",
  "www.google.es": "organic",
  "www.haosou.coms": "organic",
  "www.kvasir.no": "organic",
  "www.lycos.com": "organic",
  "www.mamma.com": "organic",
  "www.msn.com": "organic",
  "www.mynet.com": "organic",
  "www.naver.com": "organic",
  "www.ozu.es": "organic",
  "www.qwant.com": "organic",
  "www.seznam.cz": "organic",
  "www.so.coms": "organic",
  "www.sogou.com": "organic",
  "www.startsiden.nosok": "organic",
  "www.szukacz.pl": "organic",
  "www.voila.fr": "organic",
  "www.wp.pl": "organic",
  "www.yahoo.com": "organic",
  "www.yam.com": "organic",
  "www.yandex.com": "organic",
  "yahoo.cn": "organic",
  "yandex.ru": "organic",
  "yz.m.sm.cn": "organic",
  "zhidao.baidu.com": "organic",
  "www.google.ch": "organic",
  "www.google.com.ar": "organic",
  "www.google.dk": "organic",
  "com.google.android.googlequicksearchbox": "organic",
  // Social
  "es-la.facebook.com": "social",
  "es.linkedin.com": "social",
  "facebook.com": "social",
  "instagram.com": "social",
  "l.facebook.com": "social",
  "l.instagram.com": "social",
  "l.wl.co": "social",
  "linkedin.com": "social",
  "linkedin.my.salesforce.com": "social",
  "linktr.ee": "social",
  "lm.facebook.com": "social",
  "lnkd.in": "social",
  "m.facebook.com": "social",
  "mobile.twitter.com": "social",
  "review.internmc.facebook.com": "social",
  "t.co": "social",
  "twitter.com": "social",
  "web.facebook.com": "social",
  "www.facebook.com": "social",
  "www.youtube.com": "social",
  "youtu.be": "social",
  "youtube.com": "social",
  "m.youtube.com": "social",
  "www.linkedin.com": "social",
  // Email
  "click.info.capitaria.com": "email",
  "correo.vera.com.uy": "email",
  "email-app.s10.marketingcloudapps.com": "email",
  "mail.google.com": "email",
  "mail.yahoo.com": "email",
  "outlook.live.com": "email",
  "view.info.capitaria.com": "email"
};
exports.DOMAINS = DOMAINS;
var DOMAINS_MC_ORIGEN = {
  // Blog
  "blog.capitaria.com": "Blog",
  // Directo
  "webpay3g.transbank.cl": "Directo",
  "fiebredeloro.net": "Directo",
  "webpay3gint.transbank.cl": "Directo",
  // Organico
  "baidu.com": "Organico",
  "bottraffic4free.xyz": "Organico",
  "m.sogou.com": "Organico",
  "es.search.yahoo.com": "Organico",
  "cl.search.yahoo.com": "Organico",
  "m.baidu.com": "Organico",
  "ar.search.yahoo.com": "Organico",
  "googleapis.com": "Organico",
  "int.search.tb.ask.com": "Organico",
  "yz.m.sm.cn": "Organico",
  "co.search.yahoo.com": "Organico",
  "mx.search.yahoo.com": "Organico",
  "pe.search.yahoo.com": "Organico",
  "search.becovi.com": "Organico",
  "search.visymo.com": "Organico",
  "searchencrypt.com": "Organico",
  "wap.sogou.com": "Organico",
  "capitaria-online.com": "Organico",
  "cbsearch.site": "Organico",
  "ccyy.ooo": "Organico",
  "news.google.com": "Organico",
  "search.mysearch.com": "Organico",
  "so.com": "Organico",
  "so.m.sm.cn": "Organico",
  "sogou.com": "Organico",
  "tw.search.yahoo.com": "Organico",
  "uk.search.yahoo.com": "Organico",
  "ve.search.yahoo.com": "Organico",
  "zhidao.baidu.com": "Organico",
  "google.com": "Organico",
  "google.cl": "Organico",
  "google.com.mx": "Organico",
  "google.com.pe": "Organico",
  "google.com.uy": "Organico",
  "google.com.co": "Organico",
  "google.com.br": "Organico",
  "www.google.com": "Organico",
  "www.google.cl": "Organico",
  "www.google.com.mx": "Organico",
  "www.google.com.pe": "Organico",
  "www.google.com.uy": "Organico",
  "www.google.com.co": "Organico",
  "www.google.com.br": "Organico",
  "com.google.android.googlequicksearchbox": "Organico",
  "www.ecosia.org": "Organico",
  "www.google.ch": "Organico",
  "www.google.com.ar": "Organico",
  "www.google.com.hk": "Organico",
  "www.google.dk": "Organico",
  "google.ch": "Organico",
  "google.com.ar": "Organico",
  "google.com.hk": "Organico",
  "google.dk": "Organico",
  // Facebook
  "facebook.com": "Facebook",
  "www.facebook.com": "Facebook",
  "es-la.facebook.com": "Facebook",
  "m.facebook.com": "Facebook",
  "l.facebook.com": "Facebook",
  "lm.facebook.com": "Facebook",
  "review.internmc.facebook.com": "Facebook",
  "web.facebook.com": "Facebook",
  // Linkedin
  "linkedin.com": "Linkedin",
  "lnkd.in": "Linkedin",
  "linkedin.my.salesforce.com": "Linkedin",
  "es.linkedin.com": "Linkedin",
  "www.linkedin.com": "Linkedin",
  // Twitter
  "twitter.com": "Twitter",
  "t.co": "Twitter",
  "mobile.twitter.com": "Twitter",
  // Referral
  "aprendotrading.com": "Referral",
  "fintechile.org": "Referral",
  "gofestchile.com": "Referral",
  "americaeconomia.com": "Referral",
  "bestonlineforexbrokers.com": "Referral",
  "bancapersonas.bancoestado.cl": "Referral",
  "cloud.info.capitaria.com": "Referral",
  // Youtube
  "youtube.com": "Youtube",
  "m.youtube.com": "Youtube",
  // Email
  "outlook.live.com": "Email",
  "mail.google.com": "Email",
  "mail.yahoo.com": "Email",
  "correo.vera.com.uy": "Email",
  "email-app.s10.marketingcloudapps.com": "Email",
  "view.info.capitaria.com": "Email",
  "click.info.capitaria.com": "Email",
  // Whatsapp
  "l.wl.co": "Whatsapp",
  // Soporte
  "capitaria.zendesk.com": "Soporte",
  // Instagram
  "instagram.com": "Instagram",
  "l.instagram.com": "Instagram",
  "linktr.ee": "Instagram",
  // One Signal
  "app.onesignal.com": "One Signal"
};
exports.DOMAINS_MC_ORIGEN = DOMAINS_MC_ORIGEN;